export const Paths = {
  home: "/",
  login: "/login",
  signup: "/signup",
  forgot: "/forgot-password",
  callback: "/callback",
  verifyEmail: "/verify-email",
  userType: "/user-type",
  recoverPassword: "/recover-password",
  welcome: "/welcome",
  registration: "/register",
  paymentAndTax: "/paymentAndTax",
  // legalRequirements: "/legalRequirements"
  verification: "/verification",
  aifilter: "/aifiller",
  tourManagementCreate: "/tourManagement/create",
  tourManagementPackageName: "/tourManagement/create/packageName",
  tourManagementPackageDescription: "/tourManagement/create/description",
  tourManagementPackageLocation: "/tourManagement/create/location",
  tourManagementPackageKeywords: "/tourManagement/create/keywords",
  tourManagementPackageInclusion: "/tourManagement/create/inclusions",
  tourManagementPackageGuideInfo: "/tourManagement/create/guideinfo",
  tourManagementPackageFood: "/tourManagement/create/food",
  tourManagementPackageTransportation: "/tourManagement/create/transportation",
  tourManagementPackageExtraInfo: "/tourManagement/create/extrainfo",
  tourManagementPackagePhotoUpload: "/tourManagement/create/photoupload",
  tourManagementPackageOptions: "/tourManagement/create/options",
  tourManagementPackageOptionsSetup: "/tourManagement/create/options/setup",
  tourManagementPackageOptionsMeeting:
    "/tourManagement/create/options/meettingpoint",
  tourManagementPackageOptionsConnectivity:
    "/tourManagement/create/options/connectivity",
  tourManagementPackageOptionsAvailability:
    "/tourManagement/create/options/availability",
  tourManagementPackageOptionsAvailabilitySchedule:
    "/tourManagement/create/options/availability/schedule",
  tourManagementPackageOptionsAvailabilityPriceCategory:
    "/tourManagement/create/options/availability/pricecategory",
  tourManagementPackageOptionsAvailabilityCapacity:
    "/tourManagement/create/options/availability/capacity",
  tourManagementPackageOptionsAvailabilityPrice:
    "/tourManagement/create/options/availability/price",
  tourManagementPackageOptionsAvailabilityAddOn:
    "/tourManagement/create/options/availability/addon",
  tourManagementPackageOptionsCutOff: "/tourManagement/create/options/cutOff",
  tourManagementPackageOptionsCancelationPolicy:
    "/tourManagement/create/option/cancelationPolicy",
  availablity: "/availablity",
  booking: "/booking",
  specialOffers: "/create/special-offer",
  manageSpecialOffers: "/manage/special-offer",
  manageProduct: "/manage/product",
  manageProductDetails: "/manage/product/:id",
  manageProductOptionsDetails: "/manage/product/:id/:optionId",
  createProtocol: "/create/protocol",
  finance: "/finance",
  privacyPolicy: "/privacy-policy",
};
